import { connect } from 'react-redux'
import ExamplesTable from './examples-table'
import { getExamplesList } from '../../../../../stores/examples/examples.selectors'

const mapStateToProps = state => ({
  examples: getExamplesList(state)
})

export default connect(mapStateToProps, null)(ExamplesTable)
